// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fc-0";